import { takeLatest, call, put } from 'redux-saga/effects';
import _ from 'lodash';

import {
  FETCH_TASK,
  fetchTaskSuccess,
  fetchTaskFailed,
  fetchingTask,
  UPLOAD_TASKS,
  uploadingTasks,
  uploadTasksSuccess,
  uploadTasksFailed,
} from '../actions/tasks';

import {
  fetchTasksRoutine, saveTaskAssignmentsRoutine, editTaskRoutine, removeTasksRoutine,
} from '../routines';
import { update, updateSaga, updateColSaga } from './helper';
import { showError } from '../actions/dialogs';
import { post } from '../utils/rest';
import { convertCollection } from '../utils/helper';

import { firestore, getTenantPath, getTenantId } from '../utils/firebase';

function enrichTask(task) {
  return Promise.resolve(task);
}

function fetchTasks(jobId) {
  return firestore.collection('tasks').where('tenantId', '==', getTenantId()).where('jobId', '==', jobId)
    .get()
    .then(convertCollection)
    .then((data = {}) => {
      const tasks = _.omitBy((data), (task) => task.deleted);
      console.log('tasks fetch', _.keys(tasks).length);
      return tasks;
    });
}

function* fetchTasksSaga(action) {
  try {
    const tasks = yield call(fetchTasks, action.payload.jobId);
    yield put(fetchTasksRoutine.success({ jobId: action.payload.jobId, tasks }));
  } catch (e) {
    console.error('Failed to load tasks', e);
    yield put(showError('Error', 'Failed to retrieve tasks'));
    yield put(fetchTasksRoutine.failure(action.jobId, e));
  }
}

function* watchFetchTasksSaga() {
  yield takeLatest(fetchTasksRoutine.TRIGGER, fetchTasksSaga);
}

function fetchTask(taskId) {
  return firestore.doc(`tasks/${taskId}`).get().then((data) => enrichTask(data.data()));
}

function* fetchTaskSaga(action) {
  try {
    yield put(fetchingTask());
    const task = yield call(fetchTask, action.taskId);
    yield put(fetchTaskSuccess(task));
  } catch (e) {
    console.error('Failed to load task', e);
    yield put(fetchTaskFailed(e));
  }
}

function* watchFetchTaskSaga() {
  yield takeLatest(FETCH_TASK, fetchTaskSaga);
}

function uploadTasks(job, tasks, taskProfile) {
  const path = `/v1/tenants/${getTenantId()}/jobs/${job.id}/tasks`;
  return post(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ tasks, taskProfile }),
  }).then((resp) => {
    return resp;
  }).catch((err) => {
    throw new Error(err.message);
  });
}

function* uploadTasksSaga(action) {
  try {
    yield put(uploadingTasks(action.job, action.tasks));
    const tasks = yield call(uploadTasks, action.job, action.tasks, action.taskProfile);
    yield put(uploadTasksSuccess(action.job, tasks));
  } catch (e) {
    console.error('Failed to upload tasks', e);
    yield put(showError('Error', 'Failed to upload tasks'));
    yield put(uploadTasksFailed(action.job, e));
  }
}

function* watchUploadTasksSaga() {
  yield takeLatest(UPLOAD_TASKS, uploadTasksSaga);
}

// function* saveTaskAssignmentsSaga(action) {
//   console.log('saveTaskAssignmentsSaga', 'saving tasks', action.payload);
//   const assignments = action.payload.reduce((res, task) => {
//     const stages = _.keys(task.stages).reduce((res2, stageId) => {
//       if (task.stages[stageId].assignedTo) {
//         return _.assign(res2, { assignedTo: task.stages[stageId].assignedTo });
//       }
//
//       return res2;
//     }, {});
//     return _.assign(res, { [task.id]: { stages } });
//   }, {});
//
//   console.log('assignments', assignments);
//
//   return updateSaga(saveTaskAssignmentsRoutine, () => getTenantPath('tasks'));
//
//   // try {
//   //   yield put(uploadingTasks(action.job, action.tasks));
//   //   const tasks = yield call(uploadTasks, action.job, action.tasks);
//   //   yield put(uploadTasksSuccess(action.job, tasks));
//   // } catch (e) {
//   //   console.error('Failed to upload tasks', e);
//   //   yield put(uploadTasksFailed(e));
//   // }
// }

function* watchSaveTaskAssignmentsSaga() {
  yield takeLatest(saveTaskAssignmentsRoutine.TRIGGER, updateSaga(saveTaskAssignmentsRoutine, () => getTenantPath('tasks'), (tasks) => {
    console.log('saveTaskAssignmentsSaga', 'saving tasks', tasks);
    const assignments = tasks.reduce((res, task) => {
      _.keys(task.stages).forEach((stageId) => {
        if (task.stages[stageId].assignedTo) {
          res[`${task.id}/stages/${stageId}/assignedTo`] = task.stages[stageId].assignedTo;
        }
      });
      return res;
    }, {});

    console.log('assignments', assignments);

    return assignments;
  }));
}

function* watchRemoveTasksSaga() {
  yield takeLatest(removeTasksRoutine.TRIGGER, updateColSaga(removeTasksRoutine, () => 'tasks', ({ tasks }) => {
    console.log('removeTasksSaga', tasks);
    const removals = tasks.reduce((res, task) => {
      res[task.id] = { deleted: { at: new Date().toISOString() } };
      return res;
    }, {});

    console.log('removals', removals);

    return removals;
  }));
}

function saveTask(task) {
  return update(`/tasks/${task.id}`, task)
    .then(() => task);
}

function* editTaskSaga(action) {
  const task = action.payload.toJS();
  try {
    // trigger request action
    yield put(editTaskRoutine.request(task));
    // perform request to '/some_url' to fetch some data
    const response = yield call(saveTask, task);
    // if request successfully finished
    yield put(editTaskRoutine.success({ success: true, task: response }));
  } catch (err) {
    console.error('Unable to save task', err);
    yield put(editTaskRoutine.failure({ success: false, error: err.message }));
    yield put(showError('Error', 'Failed to update task'));
  } finally {
    // trigger fulfill action
    yield put(editTaskRoutine.fulfill());
  }
}
function* watchEditTaskSaga() {
  yield takeLatest(editTaskRoutine.TRIGGER, editTaskSaga);
}
export {
  // fetchTasksSaga,
  watchFetchTasksSaga,
  // fetchTaskSaga,
  watchFetchTaskSaga,
  // uploadTasksSaga,
  watchUploadTasksSaga,
  watchSaveTaskAssignmentsSaga,
  watchEditTaskSaga,
  watchRemoveTasksSaga,
};



// WEBPACK FOOTER //
// ./src/sagas/tasks.js